<template>
    <div>
        <HeaderStock header="ตั้งค่าข้อมูลเกี่ยวกับคลัง" :img_header="header_image" link_back="stock" />
        <MenuStockSetting/>
        <StockUnitList/>
    </div>
</template>

<script>
import HeaderImage from '@/assets/icon-stock-setting.png'
import HeaderStock from '@/components/menuadmin/stock/stockheader/HeaderStock.vue'
import MenuStockSetting from '@/components/menuadmin/stock/stocksetting/MenuStockSetting.vue'
import StockUnitList from '@/components/menuadmin/stock/stocksetting/StockUnitList.vue'
export default {
    name:'stockUnit',
    components:{
        HeaderStock,
        MenuStockSetting,
        StockUnitList,
    },
    data(){
        return{
            header_image:HeaderImage
        }
    }
}
</script>